
/**
 * Controller para la busqueda
 * @author jkudla
 */
angular.module('mapes').controller('SearchCtrl', function (
  $rootScope,
  $scope,
  Centres,
  DataService,
  EnsenyamentsData,
  NotificationsService,
  SharedProperties,
  ServeisEducatius,
) {

  $scope.button = {
    text: "Cerca",
    cssClass: '',
    hideLoading: true,
    textLoading: 'Carregant ',
    cssClassLoading: 'loading'
  };

  $scope.search = function () {

    var bboxObj = {};

    //Inicialitzant els parametres de cerca.
    paramsMapes.codiCentre = null;
    paramsMapes.nom = null;
    paramsMapes.codiServeiTerritorial = null;
    paramsMapes.codiComarca = null;
    paramsMapes.codiMunicipi = null;
    paramsMapes.codiDistricte = null;
    paramsMapes.codiNaturalesa = null;
    paramsMapes.ensenyaments = null;
    paramsMapes.tipusSuport = null;
    paramsMapes.educacioEspecial = false;
    paramsMapes.acronim = null;
    paramsMapes.sortBy = null;
    paramsMapes.sentitOrdre = 'asc';
    paramsMapes.curs = SharedProperties.getSelectedCurs();
    paramsMapes.rpp = 10;
    paramsMapes.pageActual = 1;
    paramsMapes.registreInicial = 1;
    paramsMapes.registreFinal = 10;

    NotificationsService.closeMessage();
    //buscamos los ensenyaments selecionados 
    const ensenyaments = Utils.findBy(EnsenyamentsData.ensenyaments, 'value', true);
    const educacioEspecial = Utils.findBy(EnsenyamentsData.eduEspecial, 'value', true);
    const naturalesas = Utils.findBy(EnsenyamentsData.naturalesas, 'value', true);
    const tipusSuport = Utils.findBy(EnsenyamentsData.tipusSuport, 'value', true);
    let filter = "(1=1) ";
    const isTerritorialFiltered = checkFiltreTerritorial(
      DataService.comarca.codiComarca,
      DataService.municipi.codiMunicipi,
      DataService.serveisTerritorial.codiServeiTerritorial,
      DataService.districte.codiDistricte
    );
    const doSearch = checkDoSearch(ensenyaments, educacioEspecial, isTerritorialFiltered);

    if (!!educacioEspecial.length && doSearch) {
      paramsMapes.educacioEspecial = true;
      filter += " AND (ES_ESPECIAL='S')";
    }

    //Es realitzen comprovacions de diferents paràmetres, a més d'assegurar que el curs estigui seleccionat
    if (
      !!naturalesas.length ||
      !!tipusSuport.length ||
      (doSearch && checkCursSelected(paramsMapes.curs))
    ) {
      //Buscar per centre. Montamos los filtros para el geoserver
      if (DataService.cercarPer === 1) {
        //miramos si el valor en nomCentre no es numerico
        if (!(/^\d+$/.test(DataService.centre.nomCentre))) {
          paramsMapes.nom = DataService.centre.nomCentre;
          paramsMapes.codiCentre = DataService.centre.codiCentre;
        } else {
          paramsMapes.nom = null;
          paramsMapes.codiCentre = DataService.centre.nomCentre;
        }

        if (paramsMapes.codiCentre != null && paramsMapes.codiCentre !== "") {
          if (paramsMapes.codiCentre.length < 8) {
            filter += " AND (CODI_CENTRE ILIKE '%" + paramsMapes.codiCentre + "%' )";
          } else {
            filter += " AND (CODI_CENTRE= '" + paramsMapes.codiCentre + "' )";
          }
        }

        if (paramsMapes.nom != null && paramsMapes.nom !== "") {
          var nomCentre = nomCentreParser(paramsMapes.nom);
          filter += " AND (NOM_ORDENAR ILIKE '%" + nomCentre.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '') + "%' )";
        }

        if (ensenyaments.length > 0) {
          filter += " AND " + EnsenyamentsData.getEnsenyamentsFilter(ensenyaments);
        }

        if (naturalesas.length > 0) {
          const naturalesasFilter = EnsenyamentsData.getNaturalesasFilter(naturalesas, paramsMapes.curs.length !== 0);
          if (naturalesasFilter) {
            filter += " AND " + naturalesasFilter;
          }
          paramsMapes.codiNaturalesa = EnsenyamentsData.getElementsSQLFilter(naturalesas);
        }

        if (tipusSuport.length > 0) {
          filter += " AND ";
          filter += EnsenyamentsData.getSuportsFilter(tipusSuport);
          paramsMapes.tipusSuport = EnsenyamentsData.getElementsSQLFilter(tipusSuport);
        }

        var geoFilter = DataService.getFilter();
        if (geoFilter !== "") {
          filter += " AND ";
          filter += geoFilter;
        }
        var selectedCurs = paramsMapes.curs;
        if (selectedCurs.length !== 0) {
          filter += " AND ( CURS IN ( " + paramsMapes.curs + " ) )";
        }

        paramsMapes.ensenyaments = EnsenyamentsData.getElementsSQLFilter(ensenyaments);

        var geoFilter = DataService.getFilter()
        if (geoFilter !== "") {
          filter += " AND ";
          filter += geoFilter;
        }
      }

      //guardem l'ultim filtre fet servir
      SharedProperties.setLastFilter(filter);

      //montamos los params geograficos
      paramsMapes.codiComarca = DataService.comarca.codiComarca;
      paramsMapes.codiMunicipi = DataService.municipi.codiMunicipi;
      paramsMapes.codiServeiTerritorial = DataService.serveisTerritorial.codiServeiTerritorial;
      paramsMapes.codiDistricte = DataService.districte.codiDistricte;

      //informamos que empezamos la búsqueda
      $rootScope.$broadcast('searchInit');
      $rootScope.$broadcast('actionButtonInit');
      if (DataService.cercarPer === 1) {
        Centres.getCentres(paramsMapes).then((result) => {
          DataService.listCentres.centres = result.centres;
          DataService.listCentres.totalItems = result.registresTotal;
          SharedProperties.setNumResults(result.registresTotal);
          //informos que la búsqueda finalizó
          $rootScope.$broadcast('searchDone');
          $rootScope.$broadcast('actionButtonDone');
        });
      }

      //informamos el mapa
      bboxObj = setBBox();
      updateMap(filter, bboxObj, 1);
    } else {
      if (!paramsMapes.curs) {
        NotificationsService.sendMessage("Heu de seleccionar com a mínim un curs acadèmic", "info");
      } else {
        NotificationsService.sendMessage("Emplena algun camp per restringir la cerca", "info");
      }
      $rootScope.$broadcast('error');
    }
  };

  $scope.searchEdu = function () {
    var bboxObj = {};
    paramsMapes.codiCentre = null;
    paramsMapes.nom = null;
    paramsMapes.codiServeiTerritorial = null;
    paramsMapes.codiComarca = null;
    paramsMapes.codiMunicipi = null;
    paramsMapes.codiDistricte = null;
    paramsMapes.acronim = null;
    paramsMapes.sortBy = null;
    paramsMapes.acronim = null;
    paramsMapes.sentitOrdre = 'asc';
    paramsMapes.curs = SharedProperties.getSelectedCurs();
    paramsMapes.rpp = 10;
    paramsMapes.pageActual = 1;
    paramsMapes.registreInicial = 1;
    paramsMapes.registreFinal = 10;
    NotificationsService.closeMessage();
    let filter = "(1=1) ";
    const serveisEducatius = Utils.findBy(EnsenyamentsData.serveisEducatius, 'value', true);
    const isTerritorialFiltered = checkFiltreTerritorial(
      DataService.comarca.codiComarca,
      DataService.municipi.codiMunicipi,
      DataService.serveisTerritorial.codiServeiTerritorial,
      DataService.districte.codiDistricte
    );

    if (!!serveisEducatius.length || isTerritorialFiltered || DataService.centre.nomCentre) {
      if (!(/^\d+$/.test(DataService.centre.nomCentre))) {
        paramsMapes.nom = DataService.centre.nomCentre;
        paramsMapes.codiCentre = DataService.centre.codiCentre;
      } else {
        paramsMapes.nom = null;
        paramsMapes.codiCentre = DataService.centre.nomCentre;
      }

      if (paramsMapes.codiCentre != null && paramsMapes.codiCentre !== "") {
        if (paramsMapes.codiCentre.length < 8) {
          filter += " AND (CODI_CENTRE ILIKE '%" + paramsMapes.codiCentre + "%' )";
        } else {
          filter += " AND (CODI_CENTRE= '" + paramsMapes.codiCentre + "' )";
        }
      }

      if (paramsMapes.nom != null && paramsMapes.nom !== "") {
        var nomCentre = nomCentreParser(paramsMapes.nom);
        filter += " AND (NOM_ORDENAR ILIKE '%" + nomCentre.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '') + "%' )";
      }

      var geoFilter = DataService.getFilter();

      if (geoFilter !== "") {
        filter += " AND ";
        filter += geoFilter;
      }

      paramsMapes.acronim = EnsenyamentsData.getElementsSQLFilter(serveisEducatius);

      if (!!serveisEducatius.length) {
        filter += " AND " + EnsenyamentsData.getServeisEducatiusFilter(serveisEducatius);
      }

      SharedProperties.setLastFilter(filter);
      paramsMapes.codiComarca = DataService.comarca.codiComarca;
      paramsMapes.codiMunicipi = DataService.municipi.codiMunicipi;
      paramsMapes.codiServeiTerritorial = DataService.serveisTerritorial.codiServeiTerritorial;
      paramsMapes.codiDistricte = DataService.districte.codiDistricte;
      $rootScope.$broadcast('searchInit');
      $rootScope.$broadcast('actionButtonInit');

      ServeisEducatius.getCentres(paramsMapes).then((result) => {
        DataService.listCentres.centres = result.centres;
        DataService.listCentres.totalItems = result.registresTotal;
        SharedProperties.setNumResults(result.registresTotal);
        $rootScope.$broadcast('searchDone');
        $rootScope.$broadcast('actionButtonDone');
      });

      //informamos el mapa
      bboxObj = setBBox();
      updateMap(filter, bboxObj, 2);
    } else {
      if (!paramsMapes.curs) {
        NotificationsService.sendMessage("Heu de seleccionar com a mínim un curs acadèmic", "info");
      } else {
        NotificationsService.sendMessage("Emplena algun camp per restringir la cerca", "info");
      }
      $rootScope.$broadcast('error');
    }
  };

  $scope.clear = () => {
    $rootScope.$broadcast('clear');
  };

  $scope.filterOnlyNumbers = (ensenyaments) => {
    var regex = /('[0-9]*')/g;
    var found = ensenyaments.match(regex);

    var result = "";
    if (found !== null && found !== undefined) {
      found.forEach((element) => {
        result = result + element + ',';
      });
    }

    result = result.substring(0, result.length - 1);

    return result;
  };

  $scope.$on('searchOferta', () => {
    $scope.search();
  });

  function checkDoSearch(ensenyaments, educacioEspecial, checkTerritori) {
    if (
      (DataService.centre.codiCentre != null && DataService.centre.codiCentre !== "") ||
      (DataService.centre.nomCentre != null && DataService.centre.nomCentre !== "")
    ) {
      return true;
    } else {
      if (educacioEspecial.length === 0 && ensenyaments.length === 0) {
        if (checkTerritori === true) {
          return true;
        }
      } else if (educacioEspecial.length === 0 && ensenyaments.length > 0) {
        return ensenyaments.length > 0;
      } else if (educacioEspecial.length > 0 && ensenyaments.length === 0) {
        return educacioEspecial.length > 0;
      } else if (educacioEspecial.length > 0 && ensenyaments.length > 0) {
        return educacioEspecial.length > 0;
      }
    }
  }

  //Funció que comprova si s'ha establert un filtre territorial
  function checkFiltreTerritorial(codiComarca, codiMunicipi, codiServeiTerritorial, codiDistricte) {
    return !(
      (codiComarca === null || codiComarca === "") &&
      (codiMunicipi == null || codiMunicipi === "") &&
      (codiServeiTerritorial == null || codiServeiTerritorial === "") &&
      (codiDistricte == null || codiDistricte === "")
    );
  }

  function checkCursSelected(curs) {
    return curs !== "";
  }

  function conversioAccents(s) {
    if (!s) {
      return '';
    }
    return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function nomCentreParser(nom) {
    return (nom || '')
      .replace(/ç/g, 'c')
      .replace(/ñ/g, 'n')
      .replace(/[ ,'·\-]/g, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase();
  }

  //Funció per fer set del BBox del mapa en funció del filtre seleccionat
  function setBBox() {
    var bboxObj = { bboxGeo: [], bboxCentre: [] };
    var bbox = '';
    var coordX = null;
    var coordY = null;
    var centres = $scope.lastMatchesFromNameInput;

    if (!((typeof DataService.centre.coordX === 'undefined' || DataService.centre.coordX
      === "") || (DataService.centre.coordY === "" || typeof DataService.centre.coordY
        === 'undefined'))) {
      coordX = DataService.centre.coordX;
      coordY = DataService.centre.coordY;
    } else if ((/^\d+$/.test(DataService.centre.nomCentre))) {
      var codiCentre = DataService.centre.nomCentre;
      var trobat = false;
      var i = 0;

      while (!trobat && i < centres.length) {
        if (centres[i].codiCentre === codiCentre) {
          trobat = true;
          if (!((typeof centres[i].coordX === 'undefined'
            || centres[i].coordX === "") || (centres[i].coordY === ""
              || typeof centres[i].coordY === 'undefined'))) {
            coordX = centres[i].coordX;
            coordY = centres[i].coordY;
          }
        }
        i++;
      }
    }

    if ((coordX == null) || (coordY == null)) {
      if (DataService.serveisTerritorial.bbox !== ''
        && DataService.serveisTerritorial.bbox !== null) {
        bbox = (DataService.serveisTerritorial.bbox);

        if (DataService.municipi.bbox !== '' && DataService.municipi.bbox !== null) {
          bbox = DataService.municipi.bbox;
        }
        if (DataService.districte.bbox !== '' && DataService.districte.bbox !== null) {
          bbox = DataService.districte.bbox;
        }

      } else {
        if (DataService.comarca.bbox !== '' && DataService.comarca.bbox !== null) {
          bbox = DataService.comarca.bbox;
        }
        if (DataService.municipi.bbox !== '' && DataService.municipi.bbox !== null) {
          bbox = DataService.municipi.bbox;
        }
        if (DataService.districte.bbox !== '' && DataService.districte.bbox !== null) {
          bbox = DataService.districte.bbox;
        }
      }
      if (bbox !== '') {
        bboxObj.bboxGeo = bbox.split(",").map(Number);
      }
    }
    else {

      var offset = 100;
      coordX = Number((coordX).replace(",", "."));
      coordY = Number((coordY).replace(",", "."));

      var minX = coordX - offset;
      var minY = coordY - offset;
      var maxX = coordX + offset;
      var maxY = coordY + offset;

      bboxObj.bboxCentre = [minX, minY, maxX, maxY];

    }
    return bboxObj;
  }
});

